import { createSlice } from '@reduxjs/toolkit'

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuth: null,
    isAdmin: false,
    isStudent: false,
    isAdBlock: false,
    user: null,
  },
  reducers: {
    authStatusUpdated: (state,action) => {
      return {
        isAuth: action.payload.isAuth,
        isAdmin: action.payload.isAuth ? !!action.payload.isAdmin : false,
        isStudent: action.payload.isAuth ? !!action.payload.isStudent : false,
        isAdBlock: false,
        user: action.payload.isAuth ? (action.payload.user || null) : null,
      }
    },
    adBlockerStatusUpdated: (state,action) => {
        return {
            ...state,
            isAdBlock: action.payload.isAdBlock,
        }
      },
  },
})

// Action creators are generated for each case reducer function
export const { authStatusUpdated,adBlockerStatusUpdated } = authSlice.actions

export default authSlice.reducer